export enum Type {
  Mountain,
  River,
  Grass,
  Unknown,
}
